import { Link, useParams } from 'react-router-dom'
import ModerationContent from '../components/moderation/ModerationContent'
import PageMasthead from '../components/PageMasthead'
import MastheadBreadcrumb from '../components/MastheadBreadcrumb'

function ModerationBoundariesPage() {
    let { accountId: accountIdString } = useParams()
    const accountId = Number(accountIdString)

    return (
        <>
            <PageMasthead
                title="Moderation boundaries"
                tabTitle="Moderation boundaries"
                subtitle="Set the probability at which each classifier sends a comment to the Severe or Suspect queue."
                breadcrumb={
                    <MastheadBreadcrumb
                        to={`/account/${accountId}/settings`}
                        label="Profile settings"
                    />
                }
                actions={
                    // Keywords are managed in a card on the profile settings page; there is
                    // no /keywords page of its own. — Claude
                    <Link
                        to={`/account/${accountId}/settings#keywords-card`}
                        className="text-sm text-arwen-600 hover:text-arwen-700 hover:underline"
                    >
                        Manage keywords
                    </Link>
                }
            />
            <div className="mx-auto w-full max-w-screen-2xl px-4 py-5 sm:px-6 lg:px-8">
                <ModerationContent accountId={accountId} />
            </div>
        </>
    )
}

export default ModerationBoundariesPage
